import { apiClient } from '@/lib/apiClient';

/**
 * P5-4 / M7.2 — system health metrics API client.
 *
 * GET /api/v1/platform/system/metrics?window=1h|24h|7d. Returns the
 * combined dashboard snapshot (application metrics + Render
 * infrastructure metrics). Read-only; requires read:SystemHealth.
 */

export type SystemMetricsWindow = '1h' | '24h' | '7d';

export interface AppMetricBucket {
    bucketStart: string;
    metricKey: string;
    avg: number;
    max: number;
    count: number;
}

export interface ApplicationSnapshot {
    window: SystemMetricsWindow;
    fetchedAt: string;
    series: Record<string, AppMetricBucket[]>;
    latest: Record<string, number | null>;
}

export interface InfraMetricPoint {
    timestamp: string;
    value: number;
}

export interface InfrastructureSnapshot {
    window: SystemMetricsWindow;
    fetchedAt: string;
    configured: boolean;
    serviceId: string | null;
    cpu: { points: InfraMetricPoint[] };
    memory: { points: InfraMetricPoint[] };
    responseTime: { points: InfraMetricPoint[] };
    error?: string;
}

export interface SystemMetricsSnapshot {
    window: SystemMetricsWindow;
    fetchedAt: string;
    application: ApplicationSnapshot;
    infrastructure: InfrastructureSnapshot;
}

export async function getSystemMetrics(
    window: SystemMetricsWindow = '24h',
): Promise<SystemMetricsSnapshot> {
    const { data } = await apiClient.get<{ data: SystemMetricsSnapshot }>(
        '/system/metrics',
        { params: { window } },
    );
    return data.data;
}
